import { validationFailed, ValidationResult, createWarningFailure } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { useCloudFileDashboard } from "../../common/context/useCloudFileDashboard";

type QcDoneValidator = {
    validate: ({ cloudFileId }: { cloudFileId: string }) => Promise<ValidationResult>;
};

export const useQcDoneValidation = (): QcDoneValidator => {
    const { validateCloudFileToQcDone } = useCloudFileApi();
    const { areUnsavedChanges } = useCloudFileDashboard();

    const validate = async ({ cloudFileId }: { cloudFileId: string }) => {
        if (areUnsavedChanges) {
            const failure = createWarningFailure("Cloud file has unsaved changes.", "unsaved-changes");

            return validationFailed([failure]);
        }

        return await validateCloudFileToQcDone({ cloudFileId });
    };

    return {
        validate
    };
};
